import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Seo from "@/components/Seo";
import {
  LayoutDashboard, Users, Flag, ShieldCheck, Wallet, Activity, Megaphone,
  Share2, Users2, Handshake, Tags, Rocket, Wrench, HardDrive,
  HandCoins, Gift, LifeBuoy, FlaskConical, Compass, Send, BarChart3, Smartphone,
} from "lucide-react";

const GROUPS = [
  { heading: "admin_overview", title: "Übersicht", items: [
    { to: "/app/admin", end: true, key: "overview", label: "Übersicht", icon: LayoutDashboard },
  ] },
  { heading: "admin_users", title: "Nutzer", items: [
    { to: "/app/admin/users", key: "users", label: "Nutzer", icon: Users },
    { to: "/app/admin/reports", key: "reports", label: "Meldungen", icon: Flag },
    { to: "/app/admin/verify", key: "verify", label: "Coach-Verifizierung", icon: ShieldCheck },
    { to: "/app/admin/guide-analytics", key: "guide", label: "Onboarding-Guide", icon: Compass },
  ] },
  { heading: "admin_finance", title: "Finanzen", items: [
    { to: "/app/admin/finance", key: "finance", label: "Finanzen", icon: Wallet },
    { to: "/app/admin/payouts", key: "payouts", label: "Auszahlungen", icon: HandCoins },
  ] },
  { heading: "admin_growth", title: "Werbung & Wachstum", items: [
    { to: "/app/admin/ads", key: "ads", label: "Werbung", icon: Megaphone },
    { to: "/app/admin/affiliate", key: "affiliate", label: "Affiliate", icon: Share2 },
    { to: "/app/admin/programs", key: "programs", label: "Programme", icon: Gift },
    { to: "/app/admin/collab", key: "collab", label: "Collab", icon: Handshake },
  ] },
  { heading: "admin_comms", title: "Plattform-Kommunikation", items: [
    { to: "/app/admin/campaigns", key: "campaigns", label: "Kampagnen & Push", icon: Send },
    { to: "/app/admin/support", key: "support", label: "Support", icon: LifeBuoy },
  ] },
  { heading: "admin_content", title: "Community & Inhalte", items: [
    { to: "/app/admin/circles", key: "circles", label: "Kreise", icon: Users2 },
    { to: "/app/admin/categories", key: "categories", label: "Kategorien", icon: Tags },
  ] },
  { heading: "admin_tech", title: "Technik & Betrieb", items: [
    { to: "/app/admin/traffic", key: "traffic", label: "Traffic", icon: BarChart3 },
    { to: "/app/admin/smart-redirect", key: "smart-redirect", label: "Smart Redirect", icon: Smartphone },
    { to: "/app/admin/monitoring", key: "monitoring", label: "Monitoring", icon: Activity },
    { to: "/app/admin/ops", key: "ops", label: "Betrieb", icon: Wrench },
    { to: "/app/admin/storage", key: "storage", label: "Speicher", icon: HardDrive },
    { to: "/app/admin/launch", key: "launch", label: "Launch/Rollout", icon: Rocket },
    { to: "/app/admin/prelaunch", key: "prelaunch", label: "Pre-Launch", icon: FlaskConical },
  ] },
];

export const ADMIN_NAV_GROUPS = GROUPS;
export const ADMIN_NAV = GROUPS.flatMap((g) => g.items);

export default function AdminLayout() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/app" replace />;
  return (
    <div data-testid="admin-page">
      <Seo title="Admin" noindex />
      <div className="animate-fade-in"><Outlet /></div>
    </div>
  );
}
